import { useActivateBulkDevices } from "./useActivateBulkDevices";
import { useDeactivateBulkDevices } from "./useDeactivateBulkDevices";
import { useDeleteBulkSpaceAssignments } from "./useDeleteBulkSpaceAssignments";
import { useDevices } from "./useDevices";
import { useDeviceSettings } from "./useDeviceSettings";
import { useFirmwareUpdateSummary } from "./useFirmwareUpdateSummary";
import { usePostSpaceRequest } from "./useSpaceRequest";
import { useUpdateBulkDeviceAssignments } from "./useUpdateBulkDeviceAssignments";
import { useUpdateBulkDeviceUnassignments } from "./useUpdateBulkDeviceUnassignments";

export {
    useActivateBulkDevices,
    useDeactivateBulkDevices,
    useDeleteBulkSpaceAssignments,
    useDevices,
    useDeviceSettings,
    useFirmwareUpdateSummary,
    usePostSpaceRequest,
    useUpdateBulkDeviceAssignments,
    useUpdateBulkDeviceUnassignments,
};
